<template>
  <div>
    <v-container>
      <!-- Titulo y Botón para agregar productos -->
      <v-row>
        <!-- Titulo -->
        <v-col cols="5" class="py-1">
          <h1>Detalles de la Orden</h1>
        </v-col>

        <v-col
          cols="2"
          align-self="center"
          align="right"
          class="justify-center py-0"
        >
          <div class="deleteButton">
            <v-dialog v-model="deleteDialog" max-width="600" persistent>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="secondary "
                  small
                  text
                  dark
                  v-bind="attrs"
                  v-on="on"
                >
                  Vaciar lista
                </v-btn>
              </template>

              <v-card>
                <v-toolbar color="primary" dark>
                  ¿Estas seguro de vaciar la lista?
                </v-toolbar>

                <v-divider></v-divider>

                <v-container>
                  <div class="msjEliminar">
                    <p>
                      Esta acci&oacute;n eliminara todos los productos de la
                      lista.
                      <br />
                      ¿Desea continuar?
                    </p>
                  </div>
                </v-container>

                <v-divider></v-divider>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    color="red darken-1"
                    text
                    @click="deleteDialog = !deleteDialog"
                  >
                    Cancelar
                  </v-btn>

                  <v-spacer></v-spacer>

                  <v-btn color="primary" text @click="clearAll()">
                    Aceptar
                  </v-btn>

                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-col>

        <v-col cols="2" class="py-1">
          <v-select
            style="width: 144px"
            label="Productos en pantalla"
            dense
            outlined
            hide-details
            :items="table.limits"
            v-model="table.limit"
            :value="table.limit"
            @change="refreshProducts()"
          >
          </v-select>
        </v-col>

        <v-col
          cols="3"
          align-self="center"
          align="right"
          class="justify-center py-0"
        >
          <v-dialog
            transition="dialog-top-transition"
            scrollable
            max-width="600"
          >
            <!-- Botón para activar el pop-up. -->
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" width="100%">
                Agregar más productos
              </v-btn>
            </template>

            <!-- Pop-up para agregar productos a la lista. -->
            <template v-slot:default="dialog">
              <v-card color="secondary">
                <v-toolbar color="primary" dark>
                  Agregar productos a la lista
                </v-toolbar>

                <v-card-text style="height: 340px">
                  <!-- Llamado a componente para agregar productos -->
                  <toolbarQuickOrder
                    :actualizarContadores="actualizarContadores"
                    :toolbar="false"
                    :updateShopingQuantity="updateShopingQuantity"
                    :snackbar="snackbar"
                  >
                  </toolbarQuickOrder>
                </v-card-text>

                <v-card-actions color="secondary">
                  <v-spacer></v-spacer>

                  <v-btn color="red" class="text" @click="dialog.value = false">
                    Cerrar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>

      <!-- Detalles y resumen de pedido. -->
      <v-row>
        <!-- Detalles del pedido -->
        <v-col cols="9" class="pt-2">
          <v-container class="pt-0">
            <v-row>
              <v-col
                cols="12"
                class="py-1"
                v-for="item in table.products"
                :key="item.id"
              >
                <productCard
                  :actualizarContadores="actualizarContadores"
                  :refreshOrderDetail="refreshOrderDetail"
                  :updateShopingQuantity="updateShopingQuantity"
                  :producto="item"
                  :snackbar="snackbar"
                >
                </productCard>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-pagination
                  v-model="table.page"
                  @input="refreshProducts()"
                  class="my-4"
                  :length="table.pages"
                >
                </v-pagination>
              </v-col>
            </v-row>
          </v-container>
        </v-col>

        <!-- Resumen de pedido-->
        <v-col cols="3">
          <resumeCard
            :products="products"
            :updateShopingQuantity="updateShopingQuantity"
            :snackbar="snackbar"
            :key="totalArt"
          >
          </resumeCard>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import toolbarQuickOrder from "./quickorderList_child.vue";
import productCard from "./quickorderCardProduct_child.vue";
import resumeCard from "./quickorderResumenListado_child.vue";

export default {
  components: { toolbarQuickOrder, productCard, resumeCard },

  data() {
    return {
      table: {
        list: [],
        products: [],
        offset: 0,
        limits: [50, 100],
        limit: 50,
        total: 0,
        pages: 1,
        page: 1,
      },
      deleteDialog: false,
      dialog: false,
      url: "https://risoulimages.s3-us-west-2.amazonaws.com/Imagenes+Items/Imagenes/",
      cartQuantity: 0,
      pieceQuantity: 0,
    };
  },

  props: {
    totalArt: { type: Number },
    products: { type: Array },
    session: { type: Boolean },
    updateShopingQuantity: { type: Function },
    actualizarContadores: { type: Function },
    snackbar: { type: Function },
    deleteAll: { type: Function },
  },

  methods: {
    clearAll: function () {
      this.deleteAll();
      this.deleteDialog = false;
    },

    init: function () {
      var vm = this;
      vm.refreshProducts();
    },

    refreshProducts: function () {
      var vm = this;
      var offset = (vm.table.page - 1) * vm.table.limit;
      var limit = (vm.table.page - 1) * vm.table.limit + vm.table.limit;
      vm.table.products = vm.products.slice(offset, limit);
      vm.table.pages = Math.ceil(vm.table.total / vm.table.limit);
    },

    refreshOrderDetail() {
      this.$forceUpdate();
    },
  },

  computed: {
    cantidadArticulos: function () {
      return this.cartQuantity;
    },
    cantidadPiezas: function () {
      return this.pieceQuantity;
    },
  },

  watch: {},

  created() {
    var vm = this;
    vm.table.total = vm.products.length;
    var orderItems = JSON.parse(localStorage.getItem("shoppingCart"));
    if (orderItems.length > 0) this.actualizarContadores();
    this.init();
  },

  mounted() {},
};
</script>

<style lang="scss" scoped>
.text {
  color: white;
}

.v-toolbar {
  font-size: 1.6rem;
}

p {
  font-size: 1.6rem;
}

.image-td {
  max-width: 160px;
}

.truncate {
  max-width: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.row {
  font-size: 1.6rem;
}
.order-row {
  margin: 2rem;
}

.order-cant {
  margin: auto;
  width: 90%;
}

.detail-actions {
  display: inline-flex;
}

.total-col {
  display: flex;
  justify-content: flex-end;
}

.col-align {
  display: flex;
  align-items: center;
}

.num-col {
  display: flex;
  justify-content: flex-end;
}

.order-resume-row {
  margin-left: 3%;
  margin-right: 3%;
  margin-top: 4%;
  margin-bottom: 4%;
  font-weight: bold;
}

.section-title {
  margin-bottom: 0;
  font-size: 2rem;
  color: black;
  text-align: left;
}
.order-container {
  background-color: #ebebeb;
}
.order-container .col {
  padding: 0px 12px;
}

.order-container .col .code {
  padding-left: 20px;
  padding-right: 12px;
  padding-top: 0;
  padding-bottom: 0;
}

.price {
  padding: 1rem;
}

.quantity {
  width: 70%;
}
@media (min-width: 960px) {
  .quickOrder-container {
    max-width: 980px;
  }
}
@media (min-width: 1264px) {
  .quickOrder-container {
    max-width: 1129px;
  }
}
@media (min-width: 1879px) {
  .quickOrder-container {
    max-width: 1691px;
  }
}
@media (min-width: 1904px) {
  .quickOrder-container {
    max-width: 1556px;
    margin: auto;
  }
}
/* width */
.v-card__text::-webkit-scrollbar {
  width: 8px;
}

/* Track */
.v-card__text::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.v-card__text::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
.v-card__text::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.msjEliminar {
  margin: auto;
}
.msjEliminar p {
  text-align: center;
}
</style>
